/**
 * Hook de datos del **grid de un rango HISTÓRICO** de un trabajador
 * (`GET /api/v1/talonarios/<worker>/<start>/<end>`).
 *
 * Datos de servidor -> TanStack Query. Solo lectura (el rango ya no está en uso).
 * La query key incluye la sede activa, el trabajador y el rango. La query queda
 * inactiva si falta el trabajador o el rango es inválido (`start > end`).
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchTalonarioRangeGrid } from "../api";
import type { TalonarioGrid } from "../types";
import { talonarioRangeGridQueryKey } from "./queryKeys";

export function useTalonarioRangeGrid(
  worker: string,
  start: number,
  end: number,
) {
  const sedeId = getActiveSedeId();
  const valid =
    worker.length > 0 &&
    Number.isFinite(start) &&
    Number.isFinite(end) &&
    start <= end;
  return useQuery<TalonarioGrid>({
    queryKey: talonarioRangeGridQueryKey(sedeId, worker, start, end),
    queryFn: () => fetchTalonarioRangeGrid(worker, start, end),
    enabled: valid,
    staleTime: 60_000,
  });
}
